module.exports = __webpack_public_path__ + "img/cloud-slash.564c8413.svg";